export default {
  ru: "RU",
  en: "EN",
  CoursesTitle: "الدورات | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "الذكاء الاصطناعي",
    desc: "تحليل الصور الطبية باستخدام خدمات الذكاء الاصطناعي",
  },
  Module_edu: {
    title: "التعليم",
    desc: "محاكيات النظر، الدورات والمواد المفيدة للأطباء",
  },
  Module_community: {
    title: "المجتمع",
    desc: "تبادل المعرفة بين الأطباء ومناقشة الحالات السريرية",
  },
  Profile: "الملف الشخصي",
  Subscription: "الاشتراك",
  "Go to site": "الانتقال إلى الموقع",
  "Access after pay": "الدرس غير متاح بعد",
  Exit: "خروج",
  MY: "حسابي",
  Home: "الرئيسية",
  "Mobile banner text : demo":
    "قم بإنشاء حساب واحصل على وصول كامل إلى خدمات الذكاء الاصطناعي والمحاكيات",
  Platform: "المنصة للأطباء",
  "Platform info":
    "مساعدو الذكاء الاصطناعي، محاكيات النظر، الدورات والمواد المفيدة للأطباء",
  "Download app": "تحميل التطبيق",
  "Home title": "المنصة للأطباء | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "ذكاء اصطناعي",
  edu: "التعليم",
  community: "المجتمع",
  "Your courses": "دوراتك",
  "Recomended courses": "الدورات المقترحة",
  Courses: "الدورات",
  Calculator: "حاسبة",
  Plug: "الاتصال",
  "Go to": "الانتقال",
  Case: "حالة",
  Cases: "الحالات",
  "Case success": "تم التنفيذ",
  "Case unsuccess": "لم يتم التنفيذ",
  Modality: "النمط",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "لم تجد الخدمة المطلوبة؟",
  "Text us": "اكتب لنا عن ذلك",
  "I need AI for...": "أحتاج إلى خدمة ذكاء اصطناعي لـ...",
  "Thx for reply": "شكرًا على الاقتراح!",
  Send: "إرسال",
  Sent: "تم الإرسال",
  "Cannot loading reply -- adblock":
    "تعذر الإرسال. يرجى تعطيل إضافات المتصفح مثل VPN أو مانع الإعلانات",
  Favorites: "المفضلة",
  "Cases about 1": "أضف حالتك",
  "Cases about 2":
    "ناقش الحالات المثيرة، اطرح الأسئلة وتبادل الخبرات! أضف حالة، سيتم إخفاء هوية جميع الدراسات",
  "Cases about 3": "سيتم إخفاء الهوية",
  "Add case": "إضافة حالة",
  All: "الكل",
  "I upload": "تم التحميل",
  drafts: "المسودات",
  draft: "مسودة",
  "Case v2": "حالة",
  "Open study": "فتح الدراسة",
  Comments: "التعليقات",
  "Comment placeholder": "اكتب تعليقًا...",
  "Favorites about 1": "لا يوجد شيء هنا بعد، انقر على الأيقونة",
  "Favorites about 2": "بجوار الحالة المثيرة لإضافتها إلى المفضلة",
  "Comment screen info 1": "لإرفاق لقطة شاشة، ",
  "Comment screen info 2": "افتح الدراسة في العارض",
  Download: "تحميل",
  "Record Date": "تاريخ التسجيل",
  "Request a course": "طلب الدورة",
  "Request a course doned": "لقد أرسلت طلبًا للدورة",
  "Forgot password?": "نسيت كلمة المرور؟",
  "Reset password": "استعادة كلمة المرور",
  "Reset password v2": "استعادة كلمة المرور",
  "Reset password about":
    "أدخل البريد الإلكتروني المستخدم عند التسجيل. سنرسل إليك تعليمات الاستعادة",
  "Reset password about after":
    "تم إرسال رابط استعادة كلمة المرور إلى بريدك الإلكتروني",
  "Back to prev page": "العودة إلى الصفحة السابقة",
  Email: "البريد الإلكتروني",
  "Not valid email": "صيغة البريد الإلكتروني غير صالحة",
  EmailAlreadyRegistered: "البريد الإلكتروني مستخدم بالفعل",
  NotActivatedAccount: "المستخدم موجود، لكن الحساب لم يتم تفعيله بعد.",
  "Not found email": "البريد الإلكتروني غير مسجل",
  "Back to login": "العودة إلى تسجيل الدخول",
  "Email not come?": "لم يصلك البريد؟",
  "Write to support": "راسل الدعم",
  "Create new password": "إنشاء كلمة مرور جديدة",
  "Password confirm": "تأكيد كلمة المرور",
  "Min 8": "الحد الأدنى 8 رموز",
  "Two inputs don't match!": "كلمتا المرور غير متطابقتين",
  "Update password": "تحديث كلمة المرور",
  "Password updated": "تم تحديث كلمة المرور",
  "Invalid password token": "الرابط غير صالح، يرجى المحاولة مجددًا",
  "Unknown user": "مستخدم غير معروف",
  "Attach image": "إرفاق صورة",
  Remove: "حذف",
  Complain: "الإبلاغ",
  "Complain sent": "تم إرسال بلاغك بنجاح",
  owner: "المؤلف",
  assistant: "المشرف",
  "Answers 1": "إجابة",
  "Answers 2": "إجابتان",
  "Answers 3": "إجابات",
  "Add answer": "إضافة إجابة",
  "Collapse answers": "إخفاء الإجابات",
  "Image only": "<صورة>",
  "Cannot upload from mobile":
    "يمكنك تحميل الدراسات بصيغة DICOM فقط من جهاز الكمبيوتر",
  "Password rule": "أدخل على الأقل 8 رموز، منها حرف لاتيني واحد ورقم واحد",
  ReferenceCursors: "C - مؤشر ثلاثي الأبعاد",
  "bad browser for mpr":
    "قد لا يعمل MPR. نوصي باستخدام أحدث إصدار من Google Chrome",
  "Service in process": "التحميل غير متاح مؤقتًا",
  "Service in process about":
    "يمكنك تجربة ميزات الخدمة من خلال الدراسات التجريبية. سنبلغك عند توفر إمكانية المعالجة.",
  "Edit case": "تعديل الحالة",
  Title: "العنوان",
  "Access count": "عدد الوصول",
  "Access count about":
    "إذا اخترت الخيار 'متاح للجميع'، ستكون المنشور مرئية للجميع. وإذا كان عبر الرابط، يمكن الوصول إليها فقط من خلال الرابط المباشر.",
  "To All": "للجميع",
  "To Link": "عبر الرابط",
  Publish: "نشر",
  "Publish about":
    "عند النشر بشكل مجهول، لن يتم عرض اسمك أو شركتك للمستخدمين الآخرين.",
  How: "كيف",
  "As Anon": "مجهول",
  "Case accept": "أنا لا أشارك أي بيانات شخصية للمريض.",
  "User Policy": "سياسة الخصوصية",
  "Remove case": "حذف الحالة",
  "Save draft": "حفظ كمسودة",
  "Remove case success": "تم حذف الحالة بنجاح",
  "Remove case error": "فشل حذف الحالة. حاول مرة أخرى لاحقًا",
  "Update case error": "فشل تحديث الحالة. حاول مرة أخرى لاحقًا",
  Edit: "تعديل",
  "Cases v2": "الحالات",
  sec: " ث",
  "Confirm accept": "تأكيد الموافقة",
  "Remove case?": "هل تريد حذف السلسلة؟",
  "Upload AI": "قم بتحميل الدراسة بصيغة DICOM",
  "Upload edu": "قم بتحميل الحالة بصيغة DICOM أو JPEG أو PNG",
  "Upload community": "قم بتحميل الحالة بصيغة DICOM أو JPEG أو PNG",
  "As anon": "مجهول",
  status: {
    free: "مجاني",
    subscription: "باشتراك",
    draft: "مسودة",
  },
  noAcceptResult: "اشرح ما الذي لا توافق عليه",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "منصة للأطباء",
      desc: process.env.VUE_APP_INSTALL_DESC,
    },
    "community-cases": {
      title: "مجتمع طبي",
      desc: "مجتمع مهني على الإنترنت للأطباء - مناقشة الحالات، الأسئلة وتبادل الخبرات!",
    },
    home: {
      title: "منصة للأطباء",
      desc: "منصة طبية عبر الإنترنت: مساعدو الذكاء الاصطناعي، محاكيات الرؤية، دورات وموارد مفيدة للأطباء",
    },
    "ai-services": {
      title: "خدمات الذكاء الاصطناعي",
      desc: "خدمات الذكاء الاصطناعي لتشخيص الأمراض",
    },
    "edu-services": {
      title: "منصة تعليمية للأطباء",
      desc: "قائمة بالدورات التدريبية وقاعدة المعرفة للأطباء التشخيصيين.",
    },
  },
  "Video is unavailable": "الفيديو غير متاح",
  Licence:
    '© 2025 شركة ذات مسؤولية محدودة "المنصة ' +
    process.env.VUE_APP_INSTALL_NAME +
    '"، جميع الحقوق محفوظة. 121205، موسكو، مركز الابتكار سكولكوفو، شارع نوبل 7، الطابق 2، الغرفة 37، المكتب 2',
  "Policy v2": "سياسة معالجة وحماية البيانات الشخصية",
  "Site company": "موقع الشركة",
  homepage: {
    connect: "اشترك بـ ",
    cost: " / شهريًا",
    goToAI: "معالجة الدراسات",
    notAuthSub__off: {
      title: "افتح جميع ميزات مساعد الذكاء الاصطناعي",
      desc: "احصل على وصول لمساعد الذكاء الاصطناعي لأتمتة القياسات وإنشاء التقارير",
    },
    notAuthSub__on: {
      title: "خدمات الذكاء الاصطناعي لتحليل الصور الطبية",
      desc: "يُؤتمت القياسات ويُنتج تقرير الفحص. عالج 3 فحوصات مجانًا، ثم — المزيد مقابل <PRICE>",
    },
    baseSub: {
      title: "تخلص من الروتين أثناء تحليل الدراسات باستخدام الذكاء الاصطناعي",
      desc: "مساعد الذكاء الاصطناعي يقوم بالقياسات ويكتب التقرير بنقرة واحدة",
    },
    notBaseSub: {
      title: "قم بتحميل الصورة بنقرة واحدة",
      desc: "استخدم مساعد الذكاء الاصطناعي لأتمتة القياسات وإنشاء التقرير",
    },
  },
  "Start type": "ابدأ بالكتابة...",
  buy: "شراء",
  more_details: "اقرأ المزيد",
};
